import { render } from "./Babylon.vue?vue&type=template&id=3f2189a4&scoped=true&ts=true"
import script from "./Babylon.vue?vue&type=script&lang=ts"
export * from "./Babylon.vue?vue&type=script&lang=ts"

import "./Babylon.vue?vue&type=style&index=0&id=3f2189a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2189a4"]])

export default __exports__